<img
  class="sih-button__image"
  src="https://d2lomvz2jrw9ac.cloudfront.net/common/sih.png"
  alt="Steam Inventory Helper"
/>
<mat-icon
  class="sub-item"
  [svgIcon]="subIcon"
></mat-icon>
